import Vue from "vue";

const initialState = () => ({
  cachedRoutes: {},
  ignoreSave: {},
});

const state = initialState();

const actions = {
  cacheRoute({ commit }, { route, component, data }) {
    commit("ADD_CACHE_ROUTE_STATE", { route, component, data });
  },
  removeCachedRoute({ commit }, route) {
    commit("REMOVE_CACHE_ROUTE_STATE", route);
  },
  cleanIgnore({ commit }) {
    commit("CLEAN_IGNORE");
  },
  reset({ commit }) {
    commit("CLEAR_CACHE");
  },
};

const mutations = {
  ADD_CACHE_ROUTE_STATE: (state, { route, component, data }) => {
    if (route in state.ignoreSave) return;

    if (!state.cachedRoutes[route]) {
      Vue.set(state.cachedRoutes, route, {});
    }
    Vue.set(state.cachedRoutes[route], component, data);
  },
  REMOVE_CACHE_ROUTE_STATE: (state, route) => {
    Vue.delete(state.cachedRoutes, route);
    Vue.set(state.ignoreSave, route, new Date().getTime());
  },
  CLEAN_IGNORE: (state) => {
    const time = new Date().getTime() - 1000;
    for (let route in state.ignoreSave) {
      if (state.ignoreSave[route] < time) {
        Vue.delete(state.ignoreSave, route);
      }
    }
  },
  CLEAR_CACHE: (state) => {
    Vue.set(state, "cachedRoutes", {});
    Vue.set(state, "ignoreSave", {});
  },
};

const getters = {
  cachedRoutes: (state) => state.cachedRoutes,
  ignoreSave: (state) => state.ignoreSave,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
